<mat-form-field subscriptSizing="dynamic" class="composite-field">
  <mat-label>{{ title }}</mat-label>
  <input #searchInput matInput
         autocomplete="off"
         type="text"
         (input)="onInput()"
         (keydown.enter)="submit()">
  @if (hasValue) {
    <button matSuffix mat-icon-button type="button" (click)="onClearClick()" aria-label="Clear">
      <mat-icon>cancel</mat-icon>
    </button>
  }
  <button matSuffix mat-icon-button type="button" (click)="submit()" aria-label="Search">
    <mat-icon>search</mat-icon>
  </button>
</mat-form-field>
